import { apiClient, createSuccessResponse, handleApiError } from "./api";

const saleService = {
  async list(page = 1, pageSize = 10, filters = {}, sortBy = null, sortOrder = null, options = {}) {
    try {
      // Construir query params manualmente
      const params = new URLSearchParams({
        page: page.toString(),
        pageSize: pageSize.toString(),
        ...filters
      });

      // Adicionar parâmetros de ordenação se fornecidos
      if (sortBy && sortOrder) {
        params.append('sortBy', sortBy);
        params.append('sortOrder', sortOrder);
      }

      const retorno = await apiClient.get(`/sale?${params.toString()}`, {
        signal: options.signal,
      });

      return {
        data : retorno.data.data,
        pagination : retorno.data.pagination,
      };
    } catch (error) {
      const processedError = handleApiError(error);
      if (processedError.code !== "CANCELED") {
        console.error("❌ [saleService] Erro ao listar vendas:", processedError);
      }
      // Cancelamento: retorna estrutura vazia sem tratar como erro
      if (processedError.code === "CANCELED") {
        return {
          data: [],
          pagination: {
            currentPage: 1,
            totalPages: 0,
            totalItems: 0,
            itemsPerPage: pageSize,
            hasNext: false,
            hasPrev: false,
          }
        };
      }
      // Tratar 404 como lista vazia (ex.: página alterada rapidamente, not-found transitório)
      if (processedError.status === 404) {
        return {
          data: [],
          pagination: {
            currentPage: 1,
            totalPages: 0,
            totalItems: 0,
            itemsPerPage: pageSize,
            hasNext: false,
            hasPrev: false,
          }
        };
      }
      return {
        success: false,
        message: processedError.message || "Erro ao carregar vendas",
        code: processedError.code,
        details: processedError.details,
      };
    }
  },

  async maxGenerateNumber() {
    try {
      const retorno = await apiClient.get("/sale/generate");

      return createSuccessResponse(retorno.data, retorno.status, retorno.message);
    } catch (error) {
      const processedError = handleApiError(error);
      return {
        success: false,
        message: processedError.message,
        status: processedError.status,
        error: processedError.error,
        code: processedError.code,
        details: processedError.details,
      };
    }
  },

  async maxGenerateNumberCodIntern() {
    try {
      const retorno = await apiClient.get("/sale/generate/codintern");

      return createSuccessResponse(retorno.data, retorno.status, retorno.message);
    } catch (error) {
      const processedError = handleApiError(error);
      return {
        success: false,
        message: processedError.message,
        status: processedError.status,
        error: processedError.error,
        code: processedError.code,
        details: processedError.details,
      };
    }
  },

  async listFilter(id, type) {
    try {
      const retorno = await apiClient.get("/sale/filter/" + id + "/" + type);

      return retorno.data;
    } catch (error) {
      const processedError = handleApiError(error);
      return {
        success: false,
        message: processedError.message,
        status: processedError.status,
        error: processedError.error,
        code: processedError.code,
        details: processedError.details,
      };
    }
  },

  async edit(id) {
    try {
      const retorno = await apiClient.get("/sale/" + id);

      return createSuccessResponse(retorno.data, retorno.status, retorno.message);
    } catch (error) {
      const processedError = handleApiError(error);
      return {
        success: false,
        message: processedError.message,
        status: processedError.status,
        error: processedError.error,
        code: processedError.code,
        details: processedError.details,
      };
    }
  },

  async save(sale) {
    try {
      console.log(sale);

      const retorno = await apiClient.post("/sale", sale, {
        timeout: 30000
      });

      return createSuccessResponse(retorno.data, retorno.status, retorno.message);
    } catch (error) {
      const processedError = handleApiError(error);
      return {
        success: false,
        message: processedError.message,
        status: processedError.status,
        error: processedError.error,
        code: processedError.code,
        details: processedError.details,
      };
    }
  },

  async update(sale) {
    try {
      console.log(sale);

      const retorno = await apiClient.put("/sale", sale);

      console.log(retorno);

      return createSuccessResponse(retorno.data, retorno.status, retorno.message);
    } catch (error) {
      const processedError = handleApiError(error);
      return {
        success: false,
        message: processedError.message,
        status: processedError.status,
        error: processedError.error,
        code: processedError.code,
        details: processedError.details,
      };
    }
  },

  async updateDate(sale) {
    try {
      console.log(sale);

      const retorno = await apiClient.put("/sale/saveSaleAlreadySend", sale);

      console.log(retorno);

      return createSuccessResponse(retorno.data, retorno.status, retorno.message);
    } catch (error) {
      const processedError = handleApiError(error);
      return {
        success: false,
        message: processedError.message,
        status: processedError.status,
        error: processedError.error,
        code: processedError.code,
        details: processedError.details,
      };
    }
  },

  async delete(idsale) {
    try {
      console.log(idsale);

      const retorno = await apiClient.delete("/sale/" + idsale);

      return createSuccessResponse(retorno.data, retorno.status, retorno.message);
    } catch (error) {
      const processedError = handleApiError(error);
      return {
        success: false,
        message: processedError.message,
        status: processedError.status,
        error: processedError.error,
        code: processedError.code,
        details: processedError.details,
      };
    }
  },

  async deleteItemCampanha(idItem, idsale) {
    try {
      console.log(idItem, idsale);

      const retorno = await apiClient.delete(
        "/sale/campanha/" + idItem + "/" + idsale
      );

      return createSuccessResponse(retorno.data, retorno.status, retorno.message);
    } catch (error) {
      const processedError = handleApiError(error);
      return {
        success: false,
        message: processedError.message,
        status: processedError.status,
        error: processedError.error,
        code: processedError.code,
        details: processedError.details,
      };
    }
  },

  async deleteItemCommission(idItem, idsale) {
    try {
      console.log(idItem, idsale);

      const retorno = await apiClient.delete(
        "/sale/comission/" + idItem + "/" + idsale
      );

      return createSuccessResponse(retorno.data, retorno.status, retorno.message);
    } catch (error) {
      const processedError = handleApiError(error);
      return {
        success: false,
        message: processedError.message,
        status: processedError.status,
        error: processedError.error,
        code: processedError.code,
        details: processedError.details,
      };
    }
  },

  async sendSale(sale) {
    try {
      console.log(sale);

      const retorno = await apiClient.put("/sendSale", sale);

      return createSuccessResponse(retorno.data, retorno.status, retorno.message);
    } catch (error) {
      const processedError = handleApiError(error);
      return {
        success: false,
        message: processedError.message || "Erro ao enviar venda",
        code: processedError.code,
        details: processedError.details,
      };
    }
  },

  async uploadPDF(formData) {
    try {
      console.log(formData);

      const retorno = await apiClient.post("/sale/uploadPdf", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      return createSuccessResponse(retorno.data, retorno.status, retorno.message);
    } catch (error) {
      const processedError = handleApiError(error);
      return {
        success: false,
        message: processedError.message,
        status: processedError.status,
        error: processedError.error,
        code: processedError.code,
        details: processedError.details,
      };
    }
  },

  async listUpload(id) {
    try {
      console.log(id);

      const retorno = await apiClient.get(
        "/download/" + id,
        { responseType: "blob" },
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      console.log(retorno);

      return retorno.data;
    } catch (error) {
      const processedError = handleApiError(error);
      return {
        success: false,
        message: processedError.message,
        status: processedError.status,
        error: processedError.error,
        code: processedError.code,
        details: processedError.details,
      };
    }
  },
};

export default saleService;
